
import { formatMoney } from 'accounting-js';

export default {
  currency: (value, symbol = '$', precision = 0) => formatMoney(value, { symbol, precision }),
  roundToNearestHundred: (value) => Math.round(value / 100) * 100
}
